import React, { useState } from 'react';
import Header from '@sharedComponent/header/header';
import { useHistory } from 'react-router-dom';
import LottieComponent from '@sharedComponent/lottie-component';
import LottieFile from '@assets/lottiefiles';
import { Col, Row, Button, Table, DatePicker, Popconfirm } from 'antd';
import { CommissionExcelDownload } from '@sharedComponent/excel/excel';
import { EditOutlined, DeleteOutlined, SwapOutlined } from '@ant-design/icons';
import moment from 'moment';
import ViewSummaryModal from './view-summary-modal';
import GifLoader from '@sharedComponent/gif-loader';
import CommissionSummaryEditTransferModal from './view-summary-edit-transfer';
import { appVariables } from '@constants';

const dateFormat = 'MM/DD/YYYY';
const ViewSummaryPresentational = ({
	formRef,
	handleSummaryForm,
	userDetails,
	onFinishModal,
	state,
	summaryForm,
	modalOptions,
	setModalOptionsValues,
	commissionSummaryByAffData,
	editCommissionSummaryByIDLoading,
	commissionSummaryByAffDataLoading,
	editCommissionSummaryByIDError,
	showCreateComm,
	setshowCreateComm
}) => {
	const history = useHistory();
	const columns = [
		{
			title: 'Customer',
			dataIndex: 'customerName',
			sorter: (a, b) => a.customerName.localeCompare(b.customerName),
			key: 'customerName',
		},
		{
			title: 'Order',
			dataIndex: 'orderId',
			key: 'orderId',
			sorter: (a, b) => a.orderId.localeCompare(b.orderId),
		},
		{
			title: 'Product',
			dataIndex: 'productName',
			sorter: (a, b) => a.productName.localeCompare(b.productName),
			key: 'productName',
		},
		{
			title: 'Product Price',
			dataIndex: 'productPrice',
			sorter: (a, b) => a.productPrice.localeCompare(b.productPrice),
			key: 'productPrice',
		},
		{
			title: 'Commission %',
			dataIndex: 'commissionPercenatage',
			sorter: (a, b) => a.commissionPercenatage.localeCompare(b.commissionPercenatage),
			key: 'commissionPercenatage',
		},
		{
			title: 'commission Amount',
			dataIndex: 'commissionPrice',
			sorter: (a, b) => a.commissionPrice - b.commissionPrice,
			key: 'commissionPrice',
			render: (value) => <Col> $ {value}</Col>,
		},
		{
			title: 'Actions',
			dataIndex: 'title',
			key: 'title',
			render: (val, row) => {
				return (
					<Row>
						<Col
							className="action_square_edit"
							xl={4}
							lg={4}
							md={4}
							sm={4}
							xs={4}
							onClick={() => setModalOptionsValues(appVariables.EDIT_COMMISSION, true, row )}>
							<EditOutlined />{' '}
						</Col>
						<Col
							className="action_square_transfer"
							xl={4}
							lg={4}
							md={4}
							sm={4}
							xs={4}
							onClick={() => setModalOptionsValues(appVariables.TRANSFER_COMMISSION, true, row)}>
							<SwapOutlined />
						</Col>
						<Col className="action_square_delete" xl={4} lg={4} md={4} sm={4} xs={4}>
							<Popconfirm
								placement="topRight"
								title={'Are you sure to delete this commission?'}
								// onConfirm={confirm}
								okText="Yes"
								cancelText="No">
								<DeleteOutlined />
							</Popconfirm>
						</Col>
					</Row>
				);
			},
		},
	];

	const dataSource = [
		{
			company: '1',
			customer: 'Joe ',
			order: 'Abc 124',
			product: 'Monthly sub',
			commissionAmount: 700,
			commission: '10%',
			totalPrice: '$12345',
		},
		{
			company: '1',
			customer: 'Joe ',
			order: 'Abc 124',
			product: 'Monthly sub',
			commissionAmount: 700,
			commission: '10%',
			totalPrice: '$12345',
		},
		{
			company: '1',
			customer: 'Joe ',
			order: 'Abc 124',
			product: 'Monthly sub',
			commissionAmount: 700,
			commission: '10%',
			totalPrice: '$12345',
		},
		{
			company: '1',
			customer: 'Joe ',
			order: 'Abc 124',
			product: 'Monthly sub',
			commissionAmount: 700,
			commission: '10%',
			totalPrice: '$12345',
		},
		{
			company: '1',
			customer: 'Joe ',
			order: 'Abc 124',
			product: 'Monthly sub',
			commissionAmount: 700,
			commission: '10%',
			totalPrice: '$12345',
		},
		{
			company: '2',
			customer: 'Joe ',
			order: 'Abc 124',
			product: 'Monthly sub',
			commissionAmount: 600,
			commission: '10%',
			totalPrice: '$12345',
		},
		{
			company: '2',
			customer: 'Joe ',
			order: 'Abc 124',
			product: 'Monthly sub',
			commissionAmount: 700,
			commission: '10%',
			totalPrice: '$12345',
		},
		{
			company: '2',
			customer: 'Joe ',
			order: 'Abc 124',
			product: 'Monthly sub',
			commissionAmount: 600,
			commission: '10%',
			totalPrice: '$12345',
		},
		{
			company: '2',
			customer: 'Joe ',
			order: 'Abc 124',
			product: 'Monthly sub',
			commissionAmount: 700,
			commission: '10%',
			totalPrice: '$12345',
		},
		{
			company: '2',
			customer: 'Joe ',
			order: 'Abc 124',
			product: 'Monthly sub',
			commission: '10%',
			totalPrice: '$12345',
			commissionAmount: 600,
		},
		{
			company: '3',
			customer: 'Joe ',
			order: 'Abc 124',
			product: 'Monthly sub',
			commissionAmount: 900,
			commission: '10%',
			totalPrice: '$12345',
		},
	];

	const footer = (value) => {
		let total = 0;
		value.map((e) => {
			total = total + e.commissionPrice;
		});
		return (
			<Row className="tb_foolter_area">
				<Col xl={1}></Col>
				<Col xl={18} className="total">
					Total
				</Col>
				<Col xl={5} className="total_amt">
					$ {total.toFixed(2)}
				</Col>
			</Row>
		);
	};

	return (
		<>
			{state.loading ? (
				<Col style={{ display: 'flex', height: '100vh', justifyContent: 'center', alignItems: 'center' }}>
					{/* <LottieComponent width="10%" height="10%" file={LottieFile.Loading} /> */}
					<GifLoader />
				</Col>
			) : (
				<>
					<Header title="Dashboard / Commission Summary/ Bri Manager" />
					<Col className="view-summary-container">
						<Row>
							<Col xl={10} lg={10} md={12} sm={24} xs={24} className="view-summary-card-header">
								{/* <RangePicker
									style={{ height: 44 }}
									defaultValue={[moment('01/01/2020', dateFormat), moment('01/02/2020', dateFormat)]}
									format={dateFormat}
								/> */}
							</Col>
							<Col xl={14} lg={14} md={12} sm={24} xs={24} className="view-summary-card-header-right">
								<Row className="status_area">
									<Col className="status_name">STATUS : </Col>
									<Col className="status_value"> PENDING</Col>
								</Row>
								<Button
									onClick={()=> {
										history.push("/create-commission-report");
									}}
									className="create-sum-btn"
									>CREATE COMM. REPORT</Button>
								<Button
									onClick={() => setshowCreateComm(true)}
									className="create-sum-btn">ADD COMM. ITEM</Button>
								{/* <Button
									type="primary"
									className="excel_download"
									icon={<DownloadOutlined />}
									style={{ borderRadius: 5 }}
									size={'middle'}>
									Export to EXCEL
									<CommissionExcelDownload
										style={{ visibility: 'hidden' }}
										dataSet={state.dataSource}
										filename={`${moment(new Date()).format(dateFormat)}_Commission_Report`}></CommissionExcelDownload>
								</Button> */}
							</Col>
						</Row>
						<Col style={{ marginTop: 15 }}>
							{commissionSummaryByAffDataLoading ?
							<Col style={{ display: 'flex', height: '300px', justifyContent: 'center', alignItems: 'center' }}>
								<GifLoader />
							</Col> : <Table
								pagination={{
									position: ['bottomCenter', 'bottomCenter'],
									defaultPageSize: 5,
									showSizeChanger: true,
									pageSizeOptions: ['5', '10'],
								}}
								dataSource={commissionSummaryByAffData.commissionModels}
								// dataSource={dataSource}
								columns={columns}
								footer={footer}
								className="commission_summary_table"
							/>}
						</Col>
						<ViewSummaryModal
							formRef={formRef}
							showCreateComm={showCreateComm}
							setshowCreateComm={setshowCreateComm}
							handleSummaryForm={handleSummaryForm}
							onFinishModal={onFinishModal}
							modalOptions={modalOptions}
							summaryForm={summaryForm}
						/>
						<CommissionSummaryEditTransferModal
							formRef={formRef}
							summaryForm={summaryForm}
							handleSummaryForm={handleSummaryForm}
							onFinishModal={onFinishModal}
							modalOptions={modalOptions}
							setModalOptionsValues={setModalOptionsValues}
							editCommissionSummaryByIDLoading={editCommissionSummaryByIDLoading}
							editCommissionSummaryByIDError={editCommissionSummaryByIDError}
						/>
					</Col>
				</>
			)}
		</>
	);
};

export default ViewSummaryPresentational;
